import React, { useId } from "react";
import { Area, AreaChart, Bar, BarChart, Cell, ResponsiveContainer } from "recharts";

// Mini grafici per le card KPI: barre (consuntivo pieno, previsionale chiaro) e area di tendenza.
export function EaMiniBars({ data, color, light, testid }) {
  if (!data?.some((x) => x.v)) return null;
  return (
    <div className="w-24 2xl:w-32 h-14 shrink-0" data-testid={testid}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 2, right: 0, bottom: 0, left: 0 }} barCategoryGap="18%">
          <Bar dataKey="v" radius={[2, 2, 0, 0]} isAnimationActive={false}>
            {data.map((x, i) => <Cell key={i} fill={x.fc ? light : color} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function EaMiniArea({ data, color, testid }) {
  const id = useId().replace(/:/g, "");
  const pts = (data || []).filter((x) => x.v != null);
  if (pts.length < 2) return null;
  return (
    <div className="w-24 2xl:w-32 h-14 shrink-0" data-testid={testid}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={pts} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
          <defs><linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity={0.45} /><stop offset="100%" stopColor={color} stopOpacity={0.03} /></linearGradient></defs>
          <Area dataKey="v" stroke={color} strokeWidth={1.5} fill={`url(#${id})`} connectNulls isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
